import { useSelectItems } from 'app/hooks/useSelectItems';
import {
  DashboardContainerHeader,
  ScrollContainer,
} from 'app/layout/dashboardLayout/BoxLayout';
import { IClientBusiness } from 'app/services/responseTypes';
import Button from 'Components/Buttons/Button';
import { NoResultsFound } from 'Components/NoResultsFound';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';
import BusinessCard from './BusinessCard';

export default function BusinessesList({ data }: { data: IClientBusiness[] }) {
  const { isAdmin, isClient } = useAuth();
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const businesses = (data || []).filter((b) =>
    b.name?.toLowerCase().includes(search?.toLowerCase()),
  );

  return (
    <ScrollContainer>
      <DashboardContainerHeader
        title={`${businesses.length !== 0 ? businesses.length : ''} Businesses`}
      >
        {isAdmin && (
          <Button
            className="max-w-min"
            theme="green-fill"
            onClick={() => navigate('create')}
          >
            Add Business
          </Button>
        )}
      </DashboardContainerHeader>

      {businesses?.length === 0 && <NoResultsFound title="No Items Found" />}
      {
        <ScrollContainer overflow="overflow-y-scroll">
          <div className="grid grid-cols-3 md-max:grid-cols-1 gap-4 p-4">
            {businesses.map((b) => (
              <BusinessCard
                value={b}
                key={b.id}
                canEdit={isClient || isAdmin}
              />
            ))}
          </div>
        </ScrollContainer>
      }
    </ScrollContainer>
  );
}
